import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CustomersService } from '@api/services/customers.service';
import { AppService } from '../../../app.service';
import { LoadingService } from '@ui/app-layout/loading-service';
import {
  afasContactDisplayName,
  CustomerDetails,
} from '@api/models/customer.model';
import { ButtonComponent } from '@ui/button/button.component';
import { CommonModule } from '@angular/common';
import { CardComponent } from '@ui/card/card.component';

@Component({
  selector: 'app-customers-details',
  standalone: true,
  imports: [CardComponent, ButtonComponent, RouterLink, CommonModule],
  template: `<div class="flex flex-col gap-4">
    <ui-card>
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-2">
          <ui-button
            [routerLink]="['/customers']"
            [icon]="'arrow-back'"
            [variant]="'ghost'"
          ></ui-button>
          <h1>{{ contactDisplayName() }}</h1>
        </div>
      </div>
    </ui-card>
    <div class="grid grid-cols-1 gap-4">
      <!-- Left Column -->
      <div class="flex flex-col gap-4">
        <!-- Customer Info Card -->
        <ui-card class="h-full" title="Klant" [loading]="loading()">
          <div class="grid grid-cols-[120px_1fr] gap-y-3 text-sm">
            <span class="text-gray-600">Naam:</span>
            <span class="font-medium">{{ contactDisplayName() }}</span>

            <span class="text-gray-600">Adres:</span>
            <span class="font-medium">
              {{ customer()?.address_street }}
              {{ customer()?.address_house_number }}
              <!-- {{ customer()?.address_house_number_addon }}, -->
              {{ customer()?.address_zipcode }}
              {{ customer()?.address_city }}
            </span>

            <span class="text-gray-600">Telefoon:</span>
            <span class="font-medium">{{
              customer()?.contactperson_phone
            }}</span>

            <span class="text-gray-600">Email:</span>
            <span class="font-medium">{{
              customer()?.contactperson_email
            }}</span>
          </div>
        </ui-card>
      </div>
    </div>
  </div>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomersDetailsComponent implements OnInit {
  customerId = inject(ActivatedRoute).snapshot.params['id'];
  customersService = inject(CustomersService);
  appService = inject(AppService);
  loadingService = inject(LoadingService);
  loading = signal<boolean>(false);
  customer = signal<CustomerDetails | null>(null);

  contactDisplayName = computed(() => afasContactDisplayName(this.customer()));

  ngOnInit() {
    this.getCustomer();
  }

  getCustomer() {
    this.loading.set(true);
    this.loadingService.show();
    this.customersService.getCustomer(this.customerId).subscribe({
      next: (customer) => {
        this.customer.set(customer);
        this.loading.set(false);
        this.loadingService.hide();
      },
      error: (error) => {
        // Error handling is now done automatically by the ErrorInterceptor
        // The loading state will be reset and error message shown
        this.loading.set(false);
      }
    });
  }
}
